<template>
  <div class="component-menu-left">
    <div class="name-project">
      <span>Nga Linh</span>
    </div>
    <div class="category-group">
      <div class="category-name">
       Danh mục chung
      </div>
      <router-link class="category-item" :to="{name: 'home-index'}" :class="[path === '' ? 'router-link-exact-active' : '']">
        <i class="fas fa-tachometer-alt"></i>
        <span>Trang chủ</span>
      </router-link>
      <router-link class="category-item" :to="{name: 'contacts-index'}" :class="[path === 'contacts' ? 'router-link-exact-active' : '']">
        <i class="fas fa-check"></i>
        <span>Liên hệ</span>
      </router-link>

      <router-link class="category-item" :to="{name: 'settings-update', params: { id: 1 }}" :class="[path === 'settings' ? 'router-link-exact-active' : '']">
        <i class="fas fa-cog"></i>
        <span>Cấu hình website</span>
      </router-link>
    </div>
    <div class="category-group">
      <div class="category-name">
        Dự án
      </div>
      <router-link class="category-item" :to="{name: 'projects-index'}" :class="[path === 'projects' ? 'router-link-exact-active' : '']">
        <i class="fas fa-umbrella"></i>
        <span>Dự án</span>
      </router-link>
    </div>
    <div class="category-group">
      <div class="category-name">
        Thiết kế
      </div>
      <router-link class="category-item" :to="{name: 'category-items-index'}" :class="[path === 'category-items' ? 'router-link-exact-active' : '']">
        <i class="far fa-list-alt"></i>
        <span>Danh mục mẫu thiết kế</span>
      </router-link>
      <router-link class="category-item" :to="{name: 'items-index'}" :class="[path === 'items' || path === 'chapters' || path === 'lessons' ? 'router-link-exact-active' : '']">
        <i class="fab fa-codepen"></i>
        <span>Mẫu thiết kế</span>
      </router-link>
    </div>
    <div class="category-group">
      <div class="category-name">
        Tin tức
      </div>
      <router-link class="category-item" :to="{name: 'category-blogs-index'}" :class="[path === 'category-blogs' ? 'router-link-exact-active' : '']">
        <i class="far fa-list-alt"></i>
        <span>Danh mục bài viết</span>
      </router-link>
      <router-link class="category-item" :to="{name: 'blogs-index'}" :class="[path === 'blogs' ? 'router-link-exact-active' : '']">
        <i class="fas fa-rss"></i>
        <span>Tin tức</span>
      </router-link>
    </div>
    <div class="category-group">
      <div class="category-name">
        Dữ liệu tài khoản
      </div>
      <router-link class="category-item" :to="{name: 'logs-index'}" :class="[path === 'logs' ? 'router-link-exact-active' : '']">
        <i class="fas fa-history"></i>
        <span>Lịch sử truy cập</span>
      </router-link>
      <router-link class="category-item" :to="{name: 'users-index'}" :class="[path === 'users' ? 'router-link-exact-active' : '']">
        <i class="fas fa-user"></i>
        <span>Tài khoản</span>
      </router-link>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
  name: 'MenuLeft',
  data () {
    return {

    }
  },
  computed: {
    ...mapGetters(['path'])
  },
  mounted () {

  },
  methods: {

  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style type="text/css" scoped>
.component-menu-left {
  height: 100vh;
}
.name-project {
  padding: 0px 25px;
  height: 50px;
  display: flex;
  align-items: center;
  font-size: 22px;
  text-transform: uppercase;
  font-weight: bold;
  letter-spacing: 1px;
}
.category-name {
  padding: 0px 25px;
  height: 30px;
  display: flex;
  align-items: center;
  text-transform: uppercase;
  font-size: 12px;
  color: #505861;
}
.category-item {
  padding: 0px 20px;
  height: 32px;
  display: flex;
  align-items: center;
  border-left: 5px solid #fff;
  cursor: pointer;
  text-decoration: none;
  color: #2c3e50;
}
.category-item:hover {
  background-color: #e4e4e4;
  transition: 0.2s;
}
.category-item i {
  margin-right: 15px;
  display: block;
  width: 20px;
}
.category-item.active {
  border-left: 5px solid #4E92DF;
  color: #4E92DF;
}

/* Active Route*/
.router-link-exact-active {
  border-left: 5px solid #4E92DF;
  color: #4E92DF;
}

</style>



// WEBPACK FOOTER //
// src/components/layouts/v1/MenuLeft.vue